import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';

import Hidden from '@material-ui/core/Hidden';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import logo from '../images/musicology-black.png';

import {
  Menu,
  ExpandLess,
} from '@material-ui/icons';

const styles = theme => ({
  header: {
    padding: 20
  },
  logo: {
    flex: 1,
    color: theme.palette.primary.main
  },
  close: {
    float: 'right'
  }
});

class MobileNavigation extends Component {

  state = {
    open: false
  };

  match = (location, name) => {
    if (!location) return;
    const levels = location.pathname.split('/');
    if (levels[1] === name) {
      return location.pathname;
    }
  }

  toggleDrawer = () => {
    this.setState({
      open: !this.state.open
    });
  }

  closeDrawer = () => {
    this.setState({ open: false });
  }

  renderListItem = (item, idx) => {
    const Icon = item.icon;
    return (
      <ListItem key={idx} onClick={this.toggleDrawer} button component={Link} to={item.link} value={item.link}>
        <ListItemIcon><Icon /></ListItemIcon>
        <ListItemText primary={item.title} />
      </ListItem>
    );
  }

  render() {
    const { open } = this.state;
    const { items, classes } = this.props;

    return(
      <div>
        <Hidden mdUp>
          <IconButton color="inherit" onClick={this.toggleDrawer}>
            <Menu />
          </IconButton>
        </Hidden>

        <Drawer
        variant="temporary"
        anchor="top"
        open={open}
        onClose={(event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      this.closeDrawer();
    }
  }}
>
            <div>
              <div className={classes.header}>
                <img src={logo} className={classes.logo} alt="musicology studio" height={40} />
                <IconButton className={classes.close} onClick={this.toggleDrawer}>
                  <ExpandLess />
                </IconButton>
              </div>
            </div>
            <Divider />
            <List>
              {items.map(this.renderListItem)}
            </List>

          </Drawer>
      </div>
    );
  }
}

export default withStyles(styles)(MobileNavigation);

